import { getAuthDashMetaCsrfToken } from '@revelio/auth';

export async function fetchJson<T>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<T> {
  const csrfToken = getAuthDashMetaCsrfToken();

  const response = await fetch(input, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-surf-token-dash-meta': csrfToken ?? '',
      ...(init?.headers || {}),
    },
    ...init,
  });

  if (!response.ok) {
    const message = await response.text();
    const error: Error & { status?: number } = new Error(
      message || 'Unknown error'
    );
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return await response.json();
}
